import Error from "./Error"
import Loading from "./Loading"
import Alert from "./Alert";
import Layout from "./Layout"
import Card from "./Card"

// eslint-disable-next-line
export default {
	Error,
	Alert,
	Loading,
	Layout,
	Card
}
